import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MaskLines, Reveal } from "../lib/motion";

// Reusable label chip
export const Label = ({ children, light = false }) => (
  <span
    className={`inline-flex items-center gap-3 text-xs font-bold uppercase tracking-[0.24em] ${
      light ? "text-clinical" : "text-clinical"
    }`}
  >
    <span className="h-[1.5px] w-8 bg-clinical" />
    {children}
  </span>
);

// Inner-page hero
export const PageHero = ({ label, titleLines, intro, image, imageAlt }) => (
  <section className="relative overflow-hidden bg-navy pt-40 pb-24 lg:pt-48 lg:pb-32">
    {image && (
      <div className="absolute inset-0">
        <img
          src={image}
          alt={imageAlt || ""}
          className="h-full w-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-navy/70" />
      </div>
    )}
    <div className="relative mx-auto max-w-[1400px] px-6 lg:px-12">
      <Reveal>
        <Label light>{label}</Label>
      </Reveal>
      <h1 className="mt-8 font-heading text-5xl font-extrabold leading-[1.02] tracking-tighter text-white sm:text-6xl lg:text-7xl">
        <MaskLines lines={titleLines} once delay={0.1} />
      </h1>
      {intro && (
        <Reveal delay={0.35}>
          <p className="mt-8 max-w-2xl text-lg leading-relaxed text-slate-300 lg:text-xl">
            {intro}
          </p>
        </Reveal>
      )}
    </div>
  </section>
);

// Contact CTA band
export const CTASection = () => (
  <section className="relative overflow-hidden bg-navy py-24 lg:py-32" data-testid="cta-section">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
      <div className="grid items-end gap-10 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <Label light>Start a Conversation</Label>
          <h2 className="mt-6 font-heading text-4xl font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
            <MaskLines
              once
              lines={["Let's build your", "private label product."]}
            />
          </h2>
          <p className="mt-6 max-w-xl text-lg text-slate-300">
            Tell us about your formulation and volume. We typically respond within
            1–2 business days.
          </p>
        </div>
        <div className="lg:col-span-4 lg:justify-self-end">
          <Link
            to="/contact"
            data-testid="cta-contact-button"
            className="group inline-flex items-center gap-3 border border-clinical bg-clinical px-8 py-4 text-base font-semibold text-white transition-colors duration-200 hover:bg-transparent"
          >
            Contact MD Labs
            <ArrowUpRight className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export { MaskLines, Reveal, motion };
